module.exports = __webpack_public_path__ + "static/media/golfer-6-b.21a82707.png";